import React from 'react';
import {useAssetProvider} from '@netx/core-asset-next/contexts';
import {
	ActionCell as BaseActionCell,
	type ActionCellProps as BaseActionCellProps,
} from '@netx/core-components/TableNext';
import {useAssetViewActions} from '../../../hooks';

export interface ActionCellProps extends Omit<
	BaseActionCellProps<any, unknown>,
	'actions'
> {}

const ActionCellPrimitive = (props: ActionCellProps) => {
	const {data: asset} = useAssetProvider();

	const {actions} = useAssetViewActions({
		asset,
		view: props.row.original,
	});

	return <BaseActionCell {...props} actions={actions} />;
};
/**
 * `ActionCell` renders an interactive table cell with an `IconButton` that triggers a menu or action, supporting accessibility and visual transitions.
 */
export const ActionCell = ActionCellPrimitive;
export default ActionCell;
